module.exports = __webpack_public_path__ + "img/spider-net.f185b396.svg";